/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum Country {
  US = "United States"
}
